import { BaseDialOptions } from './types';

export const SIZE = 100;
export const CENTER = SIZE / 2;

export const ARC_THICKNESS = 3;

export const DEFAULT_DIAL_OPTIONS: BaseDialOptions = {
  min: 0,
  max: 100,
  angleOffset: 0,
  angleRange: 360,
};
